import {useContext} from "react";
import ThemeContext from "@/src/context/theme-context";

export const useAppTheme = () => useContext(ThemeContext);